import { render, staticRenderFns } from "./record.vue?vue&type=template&id=399a284e&scoped=true&"
import script from "./record.vue?vue&type=script&lang=ts&"
export * from "./record.vue?vue&type=script&lang=ts&"
import style0 from "./record.vue?vue&type=style&index=0&id=399a284e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a284e",
  null
  
)

export default component.exports